<br />
<br />
<h4 style="font-weight:bold; text-decoration:underline; text-align:center">Selected: Disagree</h4>
<br />
<div class="container" style="border:1px solid #bebaba">
  <div class="row">
    <div class="col-md-12" style="font-weight:bold">
      <br /><br />
      Please use this form if you do not agree with the listed purchase information pre-printed on your Claim Form and you
      would like to have that information audited or you want to submit information about your purchases from Defendant House
      of Raeford that you made during January 1, 2010, through December 31, 2016 (“Class Period”). Please fill out your contact
      information and provide your annualized purchase information below.<br/><br/>

      You must submit this Purchase Audit Request Form to the mailing address listed at the top of this form or on the Settlement
      Website, www.TurkeyLitigation.com, along with your Claim Form, by October 30, 2026.
    </div>
  </div>

  <div class="container-fluid">
    <div class="row mt-5" style="margin-left: 0px; margin-right: 0px">
      <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
        Claimant Information
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="claimantsInformation" (ngSubmit)="onSubmit()">
          <div class="row mt-3">
            <div class="col-md-6">
              <div class="form-group">
                <label class="titleBold" for="pin">Pin:</label>
                <input type="text" class="form-control" id="pin" formControlName="pin" readonly />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="titleBold" for="uniqueId">Unique ID Number:</label>
                <input type="text" class="form-control" id="uniqueId" formControlName="uniqueId" readonly />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <input type="text" class="form-control" id="agreeOrDisagree" formControlName="agreeOrDisagree" hidden />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="nameOne">Company Name:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="nameOne" formControlName="nameOne" placeholder=""
                       autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.nameOne.errors }" />
                <div *ngIf="submitted && f.nameOne.errors" class="invalid-feedback">
                  <div *ngIf="f.nameOne.errors.required">This field is required</div>
                  <div *ngIf="f.nameOne.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.nameOne.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.nameOne.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="title">Title:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="title" formControlName="title" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.title.errors }" />
                <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
                  <div *ngIf="f.title.errors.required">This field is required</div>
                  <div *ngIf="f.title.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.title.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.title.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="attention">Contact Name:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="attention" formControlName="attention" placeholder=""
                       autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.attention.errors }" />
                <div *ngIf="submitted && f.attention.errors" class="invalid-feedback">
                  <div *ngIf="f.attention.errors.required">This field is required</div>
                  <div *ngIf="f.attention.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.attention.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.attention.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="streetOne">Street Address 1:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="streetOne" formControlName="streetOne" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.streetOne.errors }" />
                <div *ngIf="submitted && f.streetOne.errors" class="invalid-feedback">
                  <div *ngIf="f.streetOne.errors.required">This field is required</div>
                  <div *ngIf="f.streetOne.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.streetOne.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.streetOne.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="streetTwo">Street Address 2:</label>
                <input type="text" class="form-control" id="streetTwo" formControlName="streetTwo" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.streetTwo.errors }" />
                <div *ngIf="submitted && f.streetTwo.errors" class="invalid-feedback">
                  <div *ngIf="f.streetTwo.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.streetTwo.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.streetTwo.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row rowformat">
            <div class="col-md-6">
              <div class="form-group">
                <label for="country"><b>Country</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <select class="form-control" formControlName="country" (change)="getCountryValue($event)" [disabled]="allCountries.length === 0" [ngClass]="{ 'is-invalid': submitted && f.country.errors }">
                  <option value="">Please Select A Country</option>
                  <option *ngFor="let allcountry of allCountries">
                    {{allcountry.Name}}
                  </option>
                </select>
                <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                  <div *ngIf="f.country.errors.required">This field is required</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="city"><b>City</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" formControlName="city" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.city.errors }" />
                <div *ngIf="(changed || submitted) && f.city.errors" class="invalid-feedback">
                  <div *ngIf="f.city.errors.required">This field is required</div>
                  <div *ngIf="f.city.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.city.errors.maxlength">This field must not be at greater 40 characters</div>
                  <div *ngIf="f.city.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets,
                    ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="showDivProvince">
            <div class="row rowformat">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="province"><b>Province:</b><span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                  <input type="text" class="form-control" formControlName="province" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.province.errors }" />
                  <div *ngIf="(changed || submitted) && f.province.errors" class="invalid-feedback">
                    <div *ngIf="f.province.errors.required">This field is required</div>
                    <div *ngIf="f.province.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.province.errors.maxlength">This field must not be at greater 40 characters</div>
                    <div *ngIf="f.province.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="postalCode"><b>Postal Code:</b></label>
                  <input type="text" class="form-control" formControlName="postalCode" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.postalCode.errors }" />
                  <div *ngIf="f.postalCode.errors" class="invalid-feedback">
                    <div *ngIf="f.postalCode.errors.maxlength">This field must not be greater than 10 characters</div>
                    <div *ngIf="f.postalCode.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat" *ngIf="showDivCityStateZip">
            <div class="col-md-6">
              <div class="form-group">
                <label for="state"><b>State</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                  <option value="">Please Select A State</option>
                  <option *ngFor="let allstate of allStates" [value]="allstate.Name">
                    {{allstate.Name}}
                  </option>
                </select>
                <div *ngIf="(changed || submitted) && f.state.errors" class="invalid-feedback">
                  <div *ngIf="f.state.errors.required">This field is required</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="zip"><b>Zip Code</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" formControlName="zip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.zip.errors }" />
                <div *ngIf="(changed || submitted) && f.zip.errors" class="invalid-feedback">
                  <div *ngIf="f.zip.errors.required">This field is required</div>
                  <div *ngIf="f.zip.errors.pattern">
                    US zip Code with format 99999 or 99999-9999 alone are
                    accepted
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="email">Email Address:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="email" formControlName="email" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                  <div *ngIf="f.email.errors.required">This field is required</div>
                  <div *ngIf="f.email.errors.maxlength">This field must not be at greater 255 characters</div>
                  <div *ngIf="f.email.errors.pattern">This is not a valid email address</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="titleBold" for="phoneType">Primary Phone Type:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <select class="form-control" formControlName="phoneType" [ngClass]="{ 'is-invalid': submitted && f.phoneType.errors }">
                  <option value="">Please Select Phone Type</option>
                  <option value="Cell">Cell</option>
                  <option value="Landline">Landline</option>
                </select>
                <div *ngIf="submitted && f.phoneType.errors" class="invalid-feedback">
                  <div *ngIf="f.phoneType.errors.required">This field is required</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="titleBold" for="phoneNumber">Primary Phone Number:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" mask="000 000-0000" class="form-control" id="phoneNumber" formControlName="phoneNumber" placeholder=""
                       autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.phoneNumber.errors }" />
                <div *ngIf="submitted && f.phoneNumber.errors" class="invalid-feedback">
                  <div *ngIf="f.phoneNumber.errors.required">This field is required</div>
                  <div *ngIf="f.phoneNumber.errors.minlength">This field must be at least 10 digits</div>
                  <div *ngIf="f.phoneNumber.errors.maxlength">This field must not be at greater 10 digits</div>
                  <div *ngIf="f.phoneNumber.errors.pattern">Only use numbers</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4" style="margin-left: 0px; margin-right: 0px">
            <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
              Review Your Purchase Information
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-12">
              If you do not agree with the listed purchase information provided on your Claim Form you must complete the purchase information table
              on this form about your known Settlement qualifying purchases you made from Defendants during the Class Period. This form must reflect
              ALL of the purchases you made from the Defendants that you are claiming during the Class Period (including any purchase amounts
              prepopulated on your Claim Form).<br /><br />

              <b>
                If you agree with the listed purchase information on your claim form for all defendants, but wish to submit information about
                your purchases from Defendant House of Raeford, please mark “Agree” in the below chart for those defendants and provide the
                necessary information for House of Raeford
              </b>.  This form must reflect ALL of the purchases you made from House of Raeford
              that you are claiming during the relevant time periods Class Period<br /><br />

              You must submit this form and your Claim Form by <b>October 30, 2026</b>, (postmarked or submitted online) to the Settlement
              Administrator at the address listed above, along with additional documentation to support your dispute or supplementation.
              Documentation must include actual receipts or invoices that include the product name, name of the Defendant manufacturer,
              date of purchase, and net purchase amount. Please submit legible copies. Do not send originals.  Keep the originals for your records.<br /><br />

              <p style="font-weight:bold;text-align:center">Click on any number to edit the amount</p>

            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-6 float-left">
              <b>UniqueId:</b>  {{au.uniqueId}}
            </div>
            <div class="col-md-12 mt-3">
              <table class="table table-bordered table-striped" #listofInformation>
                <thead>
                  <tr>
                    <th>DEFENDANT</th>
                    <th>
                      2010
                    </th>
                    <th>
                      2011
                    </th>
                    <th>
                      2012
                    </th>
                    <th>
                      2013
                    </th>
                    <th>
                      2014
                    </th>
                    <th>
                      2015
                    </th>
                    <th>
                      2016
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of purchaseMatrix">
                    <td style="font-weight:bold">{{row.label}}</td>
                    <td *ngFor="let controlName of row.controls" (click)="!isEditing(controlName) && startEdit(controlName)">
                      <ng-container *ngIf="isEditing(controlName); else displayCell">
                        <input type="text"
                               class="form-control form-control-sm"
                               [formControlName]="controlName"
                               autocomplete="off"
                               trim="blur"
                               [ngClass]="{ 'is-invalid': cellControl(controlName)?.errors }"
                               (input)="recalculateTotal()"
                               (blur)="stopEdit()"
                               (keydown.enter)="stopEdit()" />
                        <div class="invalid-feedback" *ngIf="cellControl(controlName)?.errors">
                          <div *ngIf="cellControl(controlName)?.errors?.['maxlength']">Field cannot be more than 15 digits</div>
                          <div *ngIf="cellControl(controlName)?.errors?.['pattern']">Only use numbers with optional period (.) and up to 4 digits past decimal.</div>
                        </div>
                      </ng-container>
                      <ng-template #displayCell>
                        <span style="cursor:pointer">${{cellControl(controlName)?.value || 0}}</span>
                      </ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div *ngIf="showDivDisagreePurchaseMessage" class="custom-error" style="color:red; font-weight:bold; text-align:center">
                <h3>You must update at least 1 purchase amount field to submit a claim when "Disagree" is selected.</h3>
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-12" style="text-align:center; font-size:1.3em">
              <b><u>Purchase Total</u></b>&nbsp;&nbsp;&nbsp;${{f.purchaseNetTotal.value}}<br /><br />

            </div>
          </div>
          <br />
          <div class="row mt-4" style="margin-left: 0px; margin-right: 0px">
            <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
              Upload Documentation
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <br />
              Documentation must include actual receipts or invoices that include the product name, name of the Defendant manufacturer, date of purchase, and net purchase amount. Please submit legible copies. Do not send originals. Keep the originals for your records.
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-12">
              <input type="file" id="file" #fileInput (change)="getFileDetails($event)" multiple class="form-control form-control-sm hidden" />
              <label for="file" class="btn btn-primary btn-sm">Upload Documents</label>
              <br />
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <table class="table" #listofFiles>
                <thead>
                  <tr>
                    <th>Files To Be Uploaded</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let sd of supportingDocuments; let i = index">
                    <td class="hidden">{{i}}</td>
                    <td>{{sd.name}}</td>
                    <td>
                      <button type="button" class="btn btn-danger"
                              (click)="removeRow(i)">
                        Remove
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--</div>-->



          <div class="row mt-4" style="margin-left: 0px; margin-right: 0px">
            <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
              Sign Statement
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-12">
              By signing below I/we certify that (1) the above and foregoing information is true and correct; (2) I warrant that I am duly authorized and have the legal capacity to sign this Purchase Audit Request Form on behalf of the direct purchaser entity; (3) I/we are not officers, directors, or employees of any Defendant or co-conspirator; any entity in which any Defendant or co-conspirator has a controlling interest; any entity with an interest, controlling or non-controlling, in a Defendant or their co-conspirator; any entity where an individual owner, trust, and/or holding company also had an interest in any Defendant of greater than 5% during any year of the Class Period; an affiliate, legal representative, heir, or assign of any Defendant or co-conspirator; or a federal, state, or local governmental entity; a judicial officer presiding over this action and the members of his/her immediate family and judicial staff; or a co-conspirator identified in this action; (4) I/we did not previously exclude myself/themselves from the Certified Class; and (5) I/we agree to submit additional information, if requested, in order for the Settlement Administrator to process my/our claim and audit request.
            </div>
          </div>
          <br />
          <div class="row mt-4">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="signature">Electronic Signature:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.signature.errors }" />
                <div *ngIf="submitted && f.signature.errors" class="invalid-feedback">
                  <div *ngIf="f.signature.errors.required">This field is required</div>
                  <div *ngIf="f.signature.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.signature.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.signature.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" [ngClass]="{ 'is-invalid':  f.googleRecaptchaToken.errors }"></re-captcha>
                <div *ngIf="f.googleRecaptchaToken.errors" class="invalid-feedback">
                  <div *ngIf="f.googleRecaptchaToken.errors.required" style="color:red; font-size:80%">This field is required</div>
                </div>
                <!--<div style="color:#dc3545; font-size:80%; font-weight:bold">This field is required*</div>-->

              </div>
            </div>
          </div>
          <br />
          <div class="row" *ngIf="showSubmittalErrorWarning" style="background-color:lightpink">
            <div class="col-md-12 text-center" style="font-weight:bold">
              Claim Submission Failed
            </div>
          </div>
          <br />
          <ul class="list-inline text-center">
            <li><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
          </ul>
        </form>
      </div>
    </div>
  </div>
</div>
























